<template lang="pug">
div(
  v-if="idProcesso"
)
  app-modal-visualizar-completo(
    v-if="visualizarProcesso && idProcesso !== null",
    @closeModal="visualizarProcesso = false",
    :idProcesso='idProcesso',
    :protocolo="protocolo",
    :tipo="tipoProcesso"
    :numeroProcesso="numeroProcesso",
  )
  app-modal-informacao(
    v-if="informacoes",
    :idProcesso="idProcesso"
    :idDespacho="idDespacho"
    :setor='setorSelecionado'
    :setHasInformacoa="setHasInformacoa"
    @closeModal="informacoes = false"
    @setHasInformacoa="setHasInformacoa"
  )
  app-modal-solicitar-retificacao(
    v-if="solicitarRetificacao",
    :idProcesso='idProcesso',
    :numeroProcesso='numeroProcesso',
    :setor='setorSelecionado',
    :tipoProcesso='tipoProcesso'
    @closeModal="solicitarRetificacao = false"
  )
  app-modal-notificar-interessado(
    v-if="notificarInteressado",
    :idProcesso="idProcesso",
    :idDespacho="idDespacho",
    :isSubProcesso="isSubProcesso",
    @closeModal="closeModalNotificarInteressado",
    @updateHasConversa="updateHasConversa"
  )
  app-modal-legislacao(
    v-if="legislacao",
    @closeModal="legislacao = false"
  )
  app-modal-cancelar-retificacao(
    v-if="cancelarRetificacao",
    :idProcesso="idProcesso",
    :numeroProcesso="numeroProcesso",
    :setor='setorSelecionado'
    @closeModal="cancelarRetificacao = false"
  )
  app-modal-sinalizar-pendencia(
    v-if="sinalizarPendencia",
    :idProcesso="idProcesso",
    :numeroProcesso="numeroProcesso",
    :idDespacho="idDespacho",
    @closeModal="closeModalSinalizarPendencia"
    )
  app-modal-publicacao(
    v-if="publicacao",
    :idProcesso="idProcesso"
    :idDespacho="idDespacho"
    :setHasPublicacao="setHasPublicacao"
    @closeModal="publicacao = false"
    @setHasPublicacao="setHasPublicacao"
  )
  app-modal-cadastrar-protesto(
    v-if="cadastrarProtesto",
    :idProcesso="idProcesso"
    @closeModal="cadastrarProtesto = false"
    @setHasProtesto="setHasProtesto"
  )
  app-modal-visualizar-titulo(
    v-if="showVisualizarTitulo"
    titulo="Título",
    @closeModal="showVisualizarTitulo = false",
    :bytes="bytes"
  )
  el-dropdown.margin-bottom(trigger='click')
    el-button(type='info', size="small")
      | Opções
      i.el-icon-arrow-down.el-icon--right
    el-dropdown-menu(slot='dropdown')
        el-dropdown-item(v-if="btnSolicitarInformacao && opcoesHeader")
          .flex(@click="informacoes = true")
            i.material-icons.color-informacao email
            span &nbsp {{ !hasInformacao ? 'Solicitar Informação' : 'Informação'}}
        div(v-if="btnRetificacao && opcoesHeader && processoRetificavel()")
          el-dropdown-item(v-if="enableButton('SOLICITAR_RETIFICACAO') && showRetificacaoInEmissaoCertidao && !isIcmbio")
            .flex(@click="solicitarRetificacao = true")
              i.material-icons.color-refresh.color-retificacao refresh
              span &nbsp Solicitar Retificação
          el-dropdown-item(v-if="enableButton('SOLICITAR_RETIFICACAO') && showRetificacaoInEmissaoCertidao && isIcmbio")
            .flex(@click="solicitarRetificacaoIcmbio")
              i.material-icons.color-refresh.color-retificacao refresh
              span &nbsp Solicitar Retificação
        div(v-if="btnNotificarInteressado")
          el-dropdown-item(v-if="enableButton('NOTIFICAR_INTERESSADO')")
            .flex(@click="notificarInteressado = true")
              i.material-icons.color-mensagem sms
              span &nbsp {{ !hasConversa ? 'Notificar Interessado' : 'Mensagens'}}
        div(v-if="btnPendencia")
          el-dropdown-item(v-if="btnPendencia")
            .flex(@click="sinalizarPendencia = true")
              i.fa.fa-pause-circle.color-pendencia(style="font-size: 24px")
              span &nbsp {{ 'Sinalizar Pendência' }}
        el-dropdown-item
          .flex(@click="visualizarProcesso = true")
            i.material-icons.color-visualizar-processo visibility
            span &nbsp Visualizar processo
        el-dropdown-item(
          v-if="isAp && statusAtual.includes('_BASE')"
        )
          .flex(@click="visualizarTitulo()")
            i.fa.fa-award.titulo
            span &nbsp Visualizar título
        el-dropdown-item(v-if="conversaAberta && (isPa || isBa)")
          .flex(@click="fecharConversa")
            i.material-icons.color-red close
            span &nbsp Fechar conversas
        el-dropdown-item(v-if="emRetificacao && !isPa")
          .flex(@click="cancelarRetificacao = true")
            i.material-icons.color-red close
            span &nbsp Cancelar Retificação
        el-dropdown-item(v-if="EXIBIR_CONSULTA_LEGISLACAO")
          .flex(@click="legislacao = true")
            i.material-icons search
            span &nbsp Legislação
        el-dropdown-item(v-if="tipoProcesso == 'ONEROSO' && (isPa) && realizaPublicacao && !publicacaoAtiva")
          .flex(@click="publicacao = true")
            i.material-icons.color-publicacao add
            span &nbsp Realizar Publicação
        el-dropdown-item(v-if="tipoProcesso == 'ONEROSO' && (isPa) && realizaPublicacao && publicacaoAtiva")
          .flex(@click="cancelarPublicacao")
            i.material-icons.color-red close
            span &nbsp Cancelar Publicação
        el-dropdown-item(v-if="enableButton('CADASTRAR_PROTESTO') && !protestoAtivo")
          .flex(@click="cadastrarProtesto = true")
            i.el-icon-edit-outline.color-informacao(style="font-size: 20px")
            span &nbsp Cadastrar Protesto
        el-dropdown-item(v-if="enableButton('CANCELAR_PROTESTO') && protestoAtivo")
          .flex(@click="cancelarProtesto")
            i.material-icons.color-red close
            span &nbsp Cancelar Protesto
</template>

<script>
import { stringToArrayBuffer } from '@/utils/utils'
import { mapActions, mapState } from 'vuex'
import axios from '@/utils/api'
import AppModalNotificarInteressado from './AppModalNotificarInteressado'
import AppModalSolicitarRetificacao from './AppModalSolicitarRetificacao'
import AppModalSinalizarPendencia from './AppModalSinalizarPendencia'
import AppModalInformacao from './AppModalInformacao'
import AppModalLegislacao from './AppModalLegislacao'
import AppModalPublicacao from './AppModalPublicacao'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppModalCancelarRetificacao from '@/screens/analise/components/modal/AppModalCancelarRetificacao'
import AppModalCadastrarProtesto from '@/screens/analise/components/modal/AppModalCadastrarProtesto'
import AppModalVisualizarTitulo from './AppModalVisualizarTitulo.vue'
const regrasAnalise = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  components: {
    AppModalNotificarInteressado,
    AppModalSolicitarRetificacao,
    AppModalSinalizarPendencia,
    AppModalInformacao,
    AppModalLegislacao,
    AppModalPublicacao,
    AppModalCancelarRetificacao,
    AppModalCadastrarProtesto,
    AppModalVisualizarTitulo
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      visualizarProcesso: false,
      informacoes: false,
      publicacao: false,
      solicitarRetificacao: false,
      cancelarRetificacao: false,
      notificarInteressado: false,
      sinalizarPendencia: false,
      legislacao: false,
      cadastrarProtesto: false,
      cadastro: {},
      statusRetificacaoGit: ['AGUARDANDO_EMISSAO_TITULO', 'AGUARDANDO_EMISSAO_CERTIDAO', 'EM_EMISSAO_TITULO', 'EM_EMISSAO_CERTIDAO'],
      processo: {},
      isPossuiTitulo: true,
      selected: 'analise',
      hasConversa: false,
      tituloInformacao: '',
      setorSelecionado: null,
      setorCodigo: null,
      hasInformacao: false,
      idUsuario: null,
      conversaAberta: false,
      publicacaoAtiva: false,
      protestoAtivo: false,
      isPa: process.env.ESTADO === 'pa',
      isBa: process.env.ESTADO === 'ba',
      realizaPublicacao: false,
      isMa: process.env.ESTADO === 'ma',
      isIcmbio: process.env.ESTADO === 'default' || process.env.ESTADO === 'icmbio',
      isAp: process.env.ESTADO === 'ap',
      showVisualizarTitulo: false,
      bytes: null,
      statusAtual: ''
    }
  },

  computed: {
    ...mapState({
      EXIBIR_CONSULTA_LEGISLACAO: state => state.userInterface.dadosEstado.ANALISE.EXIBIR_CONSULTA_LEGISLACAO
    }),

    showRetificacaoInEmissaoCertidao () {
      if (this.isMa && this.tipoProcesso === 'REURB_INDIVIDUAL') {
        return true
      }
      return !this.isEmissaoCertidao
    }
  },

  props: {
    idProcesso: {
      required: true
    },
    statusProcesso: {
      required: false
    },
    numeroProcesso: {
      required: true
    },
    tipoProcesso: {
      required: false
    },
    protocolo: {
      required: false
    },
    idDespacho: {
      required: false
    },
    btnSolicitarInformacao: {
      default: true
    },
    btnRetificacao: {
      default: true
    },
    btnNotificarInteressado: {
      default: true
    },
    opcoesHeader: {
      default: true
    },
    isEmissaoCertidao: {
      required: false
    },
    isSubProcesso: {
      default: false
    },
    emRetificacao: {
      default: false
    },
    btnPendencia: {
      default: false
    }
  },

  async created () {
    const user = await this.getUsuario()
    this.getConversaPerdidaPendente()
    this.idUsuario = user.id
    this.setorSelecionado = user.perfilSelecionado.setor.codigo
    this.setorCodigo = user.perfilSelecionado.codigo
    this.realizaPublicacao = user.perfilSelecionado.setor.codigo.includes('GRF') || user.perfilSelecionado.setor.codigo.includes('CAF')
    await this.getConversa()
    await this.verificarPublicacaoAtiva()
    await this.verificarProtestoAtivo()
    if (this.btnSolicitarInformacao) {
      await this.updateHasInformacao()
    }
    if (this.isAp) {
      this.statusAtual = await this.getStatusAtual(this.idProcesso)
    }
  },

  methods: {
    ...mapActions({
      getUsuario: 'auth/getUsuario',
      hasConversaByProcesso: 'conversa/hasConversaByProcesso',
      encerraConversaPendente: 'conversa/encerraConversaPendente',
      retificarProcesso: 'processo/retificarProcesso',
      getStatusAtual: 'processo/getStatusAtual',
      getArrayTituloByProcessoId: 'despacho/getArrayTituloByProcessoId'
    }),
    solicitarRetificacaoIcmbio () {
      this.confirmBox(this.$messages.TEXTO_RETIFICACAO_PROCESSO_REURB_INDIVIDUAL,
        this.$messages.TITULO_WARNING,
        () => {
          this.retificarProcesso({
            conversa: {
              processo: {
                id: this.idProcesso
              }
            }
          })
            .then(() => {
              this.showNotificacao(
                this.$messages.TIPO_SUCCESS,
                this.$messages.TITULO_SUCCESS,
                this.$messages.SUCESSO_SOLICITAR_RETIFICACAO_TITULO
              )
              this.$router.back()
            })
        },
        () => {})
    },
    async getConversa () {
      const obj = {
        idUsuario: this.idUsuario,
        idProcesso: this.idProcesso,
        tipoMensagem: 'NOTIFICACAO_INTERESSADO'
      }
      this.hasConversa = await this.hasConversaByProcesso(obj)
    },
    async getConversaPerdidaPendente () {
      axios({
        method: 'GET',
        url: `conversa/processo/${this.idProcesso}/solicitacao/aberta`
      })
        .then((existe) => {
          this.conversaAberta = existe
        })
    },
    fecharConversa () {
      this.confirmBox(this.$messages.CONFIRMA_FECHAR_CONVRSA_EM_ABERTO, this.$messages.TITULO_WARNING, () => {
        axios({
          method: 'GET',
          url: `conversa/processo/${this.idProcesso}/fechar/aberta/pendente/38bb1631-4173-439e-8c25-aa85183c664c`
        })
          .then(() => {
            this.showNotificacao(
              this.$messages.TIPO_SUCCESS,
              this.$messages.TITULO_SUCCESS,
              'Conversas encerradas!'
            )
            this.conversaAberta = false
          })
      })
    },
    cancelarProtesto () {
      this.confimBoxWithInput(`
        <div style="text-align: left;">
          <div style="display: flex; flex-direction: row">
            <i class="el-icon-warning" style="color: #E6A23C; font-size: 28px; width: 100px; display: flex; justify-content: center; align-items: center"></i>
            <p>
              Após o cancelamento do protesto, este ainda será visualizado no resumo do processo.
              Tem certeza que deseja confirmar?
            </p>
          </div>
          <div style="margin-top: 12px;">
            <label for="inputField" style="display: block; font-weight: bold; margin-bottom: 4px;">
              Justificativa do cancelamento: <span style="color: red">*</span>
            </label>
          </div>
        </div>
    `,
      'Atenção',
      ({ value }) => {
        if (value) {
          const data = {
            idProcesso: this.idProcesso,
            justificativa: value
          }
          axios({
            method: 'POST',
            url: `protesto/cancelar`,
            error: true,
            data
          }).then(() => {
            this.showNotificacao(
              this.$messages.TIPO_SUCCESS,
              this.$messages.TITULO_SUCCESS,
              'O protesto foi cancelado com sucesso.'
            )
            this.protestoAtivo = false
          })
        }
      },
      () => {
      }, 'Confirmar', 'Cancelar', '', /^.{3,}$/, 'Por favor, preencha a justificativa corretamente.',
      {
        inputType: 'textarea'
      }
      )
    },
    async visualizarTitulo () {
      const bytes = await this.getArrayTituloByProcessoId(this.idProcesso)
      this.bytes = stringToArrayBuffer(bytes[0].bytes)
      this.showVisualizarTitulo = true
    },
    updateHasConversa (value) {
      this.hasConversa = value
    },
    closeModalNotificarInteressado () {
      this.notificarInteressado = false
    },
    closeModalSinalizarPendencia () {
      this.sinalizarPendencia = false
    },

    processoRetificavel () {
      if (this.tipoProcesso === null) {
        return true
      } else {
        switch (this.tipoProcesso) {
          case 'INFORMACOES':
          case 'PERMUTA':
          case 'PEAS_FILHO':
          case 'AFORAMENTO':
          case 'TRANSFERENCIA_DIREITOS':
          case 'AREAS_PATRIMONIAIS':
          case 'REURB_COLETIVO':
            return false
          default:
            return true
        }
      }
    },

    enableButton (buttonName) {
      var result = false

      switch (buttonName) {
        case 'NOTIFICAR_INTERESSADO':
          if (this.tipoProcesso !== 'REURB_COLETIVO') {
            result = regrasAnalise.notificarInteressado.perfis.includes(this.setorCodigo) && !regrasAnalise.tiposProcessoFisico.includes(this.tipoProcesso)
          }
          break

        case 'SOLICITAR_RETIFICACAO':
          if (this.tipoProcesso !== 'REGULARIZACAO_URBANA' && !this.emRetificacao) {
            if (this.setorCodigo === 'ANALISTA_GIT') {
              result = regrasAnalise.solicitarRetificacao.perfis.includes(this.setorCodigo) && this.statusRetificacaoGit.includes(this.statusProcesso)
            } else {
              result = regrasAnalise.solicitarRetificacao.perfis.includes(this.setorCodigo)
            }
          }
          break
        case 'CADASTRAR_PROTESTO':
          result = regrasAnalise.cadastrarProtesto.perfis.includes(this.setorCodigo)
          break
        case 'CANCELAR_PROTESTO':
          result = regrasAnalise.cancelarProtesto.perfis.includes(this.setorCodigo)
          break
      }
      return result
    },

    setHasInformacoa (isInformacao) {
      this.hasInformacao = isInformacao
    },

    setHasPublicacao (isPublicacao) {
      this.publicacaoAtiva = isPublicacao
    },

    setHasProtesto (isProtesto) {
      this.protestoAtivo = isProtesto
    },

    async updateHasInformacao () {
      if (this.isPa) {
        this.hasInformacao = await axios({
          method: 'GET',
          url: `solicitarInformacao/hasInformacao/processo/${this.idProcesso}`,
          error: true
        })
      } else {
        this.hasInformacao = await axios({
          method: 'GET',
          url: `solicitarInformacao/hasInformacao/processo/${this.idProcesso}/setor/${this.setorSelecionado}`,
          error: true
        })
      }
    },

    async verificarPublicacaoAtiva () {
      this.publicacaoAtiva = await axios({
        method: 'GET',
        url: `publicacao/ativa/${this.idProcesso}`,
        error: true
      })
    },

    async verificarProtestoAtivo () {
      this.protestoAtivo = await axios({
        method: 'GET',
        url: `protesto/ativo/${this.idProcesso}`,
        error: true
      })
    },

    cancelarPublicacao () {
      this.confirmBox(
        this.$messages.CONFIRMA_CANCELAR_PUBLICACAO,
        this.$messages.TITULO_WARNING,
        () => {
          axios({
            method: 'POST',
            url: `publicacao/cancelar/${this.idProcesso}`,
            error: true
          }).then(() => {
            this.showNotificacao(
              this.$messages.TIPO_SUCCESS,
              this.$messages.TITULO_SUCCESS,
              'A publicação foi cancelada com sucesso.'
            )
            this.publicacaoAtiva = false
          })
        }
      )
    }
  }
}
</script>

<style scoped lang="scss">
.label {
  font-weight: bold;
  color: #424242;
}

.margin-bottom {
  margin-bottom: 5px;
}

.color-retificacao {
  color: #f3a530;
}

.color-informacao {
  color: #104f55;
}

.color-mensagem {
  color: #01baef;
}

.color-pendencia {
  color:  #424242;
  font: 24px;
}

.color-visualizar-processo, .color-publicacao {
  color: #23a573;
}

.color-red {
  color: #D32F2F ;
}

.flex {
  display: flex;
  align-items: center;
  justify-content: left;
}

.titulo-analise {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  border-bottom: solid 1px #e6e6e6;
}

.center {
  display: flex;
  align-items: center;
}

.color {
  background-color: #104f55;
  border: solid #104f55 1px;
}

.btn {
  padding: 7px;
  margin-bottom: 10px;
}

.icon {
  font-size: 16px;
}

.titulo {
  font-size: 20px;
  margin-left: 3%;
  margin-right: 5%;
  color: #23a573;
}

@media (max-width: 780px) {
  .margin-bottom {
    margin-right: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/modal/AppOpcoesHeaderAnalise.vue